export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
} as const;

export type HttpStatus = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS] | number;

export function isClientErrorStatus(status?: number): boolean {
    return typeof status === 'number' && status >= 400 && status < 500;
}

export function isServerErrorStatus(status?: number): boolean {
    return typeof status === 'number' && status >= 500;
}

export function isRetryableStatus(status?: number): boolean {
    return (
        status === HTTP_STATUS.TOO_MANY_REQUESTS ||
        status === HTTP_STATUS.BAD_GATEWAY ||
        status === HTTP_STATUS.SERVICE_UNAVAILABLE ||
        status === HTTP_STATUS.GATEWAY_TIMEOUT ||
        isServerErrorStatus(status)
    );
}
